module.exports = __webpack_public_path__ + "img/join_01.e166277d.jpg";